import { eachDayOfInterval, endOfDay, format } from 'date-fns';
export function repeatShiftInDateRange(data) {
    const { endDate, shiftDays, repeatShift } = data;
    if (!repeatShift || !shiftDays || shiftDays.length <= 0 || !endDate) {
        return [];
    }
    const shiftsToCreate = [];
    const startDate = new Date(data.startTime);
    if (startDate > endOfDay(endDate)) {
        return [];
    }
    startDate.setDate(startDate.getDate() + 1);
    const repeatUntilDate = endOfDay(endDate);
    const allDaysInRange = eachDayOfInterval({ start: startDate, end: repeatUntilDate });
    allDaysInRange.forEach((date) => {
        const shiftStartDate = new Date(date.setHours(startDate.getHours(), startDate.getMinutes(), startDate.getSeconds()));
        const weekday = format(shiftStartDate, 'eeee').toLocaleLowerCase();
        const dateTime = shiftStartDate.getTime();
        if (shiftDays.includes(weekday) && shiftStartDate <= repeatUntilDate) {
            shiftsToCreate.push({
                data: Object.assign(Object.assign({}, data), { startTime: dateTime, duration: data.duration }),
            });
        }
    });
    return shiftsToCreate;
}
